<template>
    <header class="l-header--cabinet" v-bind:class="[openMenuButton, themeClass]">
        <div class="l-header--cabinet__wrap">
            <router-link tag="div" class="l-header--cabinet__logo-wrap"
                :to="{name: 'CabinetIndex',params: {lang: this.$route.params.lang}}">
                <div class="l-header--cabinet__logo"></div>
                <div class="l-header--cabinet__signature">Личный кабинет</div>
            </router-link>
            <div class="l-header--cabinet__menu-hamburger menu-hamburger" v-bind:class="openMenuButton"
                 v-on:click="openMenu">
                <span class="menu-hamburger__stick"></span>
                <span class="menu-hamburger__stick"></span>
                <span class="menu-hamburger__stick"></span>
                <span class="menu-hamburger__stick"></span>
            </div>

            <nav class="l-header--cabinet__menu" v-bind:class="openMenuList">
                <c-menu :theme="'dark'"></c-menu>
                <div class="l-header--cabinet__contacts">
                    <div class="l-header--cabinet__contacts--text">Контакт-центр</div>
<!--                    <a class="l-header&#45;&#45;cabinet__contacts&#45;&#45;phone" href="tel:+77273559696">+7 (727) 355-96-96</a>-->
                    <a class="l-header--cabinet__contacts--email" href="mailto:salem@micro.kz">salem@micro.kz</a>

                    <div class="l-header--cabinet__mobile-footer">
                        <ul class="l-header--cabinet__social-icons">
                            <li class="l-header--cabinet__social-icon">
                                <a class="l-header--cabinet__social-icon__item l-header--cabinet__social-icon__item--instagram" href="#" alt="Instagram"></a>
                            </li>
                            <li class="l-header--cabinet__social-icon">
                                <a class="l-header--cabinet__social-icon__item l-header--cabinet__social-icon__item--facebook" alt="Facebook" href="#"></a>
                            </li>
                        </ul>
                        <p class="l-header--cabinet__copyright">© 2024 ТОО МФО "MicroFin". Все права защищены.</p>
                    </div>
                </div>
            </nav>
        </div>
    </header>
</template>

<script>
	import widthMixin from '@/modules/mixins/widthMixin'
	import CMenu from "@/views/cabinet/cabinet/menu";

	export default {
		mixins: [widthMixin],
		name: "l-header--cabinet",
		components: {
			CMenu,
		},
		data() {
			return {
				openMenuStatus: false
			};
		},
		methods: {
			openMenu() {
				if (!this.isDesktop) {
					this.openMenuStatus = !this.openMenuStatus;
				}
			}
		},
		computed: {
			themeClass(){
				if(!this.isDesktop){
					return 'l-header--cabinet--dark'
                }else{
					return 'l-header--cabinet--light'
                }
			},
			openMenuButton() {
				return {open: this.openMenuStatus};
			},
			openMenuList() {
				return {"l-header--cabinet__menu--open": this.openMenuStatus};
			}
		}
	};
</script>

<style lang="scss">
@import "~@/assets/scss/variable";

.l-header--cabinet {
    $blockname: &;

    width: 100%;
    margin: 0 auto;
    background: #F0F0F0;
    padding: 10px;

    &__wrap {
        display: inline-flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: space-between;

        max-width: 1024px;
        width: 100%;
    }
    &__logo-wrap {
        position: relative;
        display: inline-flex;
        flex-flow: row nowrap;
        align-items: flex-end;
        justify-content: flex-start;

        z-index: 1015;
    }
    &__logo {
        width: 130px;
        height: 24px;
        background-image: url("~@/assets/svg/logo_micro.svg");
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
    }
    &__mobile-footer {
        display: none;
    }
    /*&__menu {
        display: flex;
        justify-content: space-between;

        .cabinet-menu {
            display: none;
        }
    }*/
    &__menu-list {
        list-style: none;
        display: flex;
        margin-top: 5px;
        flex: 1;
        padding: 0 20px;
        justify-content: flex-start;
        align-items: center;
    }
    &__menu-item:not(:first-child).router-link-active,
    &__menu-item.router-link-exact-active {
        border-bottom: 3px solid $violet;
        padding-bottom: 2px;
    }
    &__menu-item {
        padding: 2px 0 5px;
        margin: 0 6px;
        a {
            font-size: 15px;
            color: $black;
            font-family: $RobotoRegular;
            text-decoration: none;
            vertical-align: top;
        }
    }
    &__signature {
        align-self: flex-end;
        margin-left: 16px;
        text-align: left;
        color: $gray-dim;
        font-family: $MontserratMedium;
        font-size: 12px;
    }
    &__contacts {
        display: inline-flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: space-between;

        max-width: 650px;
        width: 100%;
        &--text {
            margin-right: 23px;
            text-align: left;
            color: #4A4A4A;
            font-family: $RobotoRegular;
            font-size: 16px
        }
        &--phone,
        &--email {
            text-align: left;
            color: $yellow-1;
            font-family: $RobotoBold;
            margin-right: 26px;
        }
        &--works {
            text-align: left;
            color: $gray-dim;
            font-family: $RobotoRegular;
            font-size: 12px
        }
    }
    &__menu-hamburger {
        display: none;
        width: 25px;
        position: relative;
        margin: 5px 0;
        transition: 0.5s ease-in-out;
        cursor: pointer;
        &__stick {
            display: block;
            position: absolute;
            height: 2px;
            width: 100%;
            background: $violet;
            border-radius: 9px;
            opacity: 1;
            left: 0;
            transform: rotate(0deg);
            transition: 0.25s ease-in-out;
            &:nth-child(1) {
                top: 0;
            }
            &:nth-child(2),
            &:nth-child(3) {
                top: 8px;
            }
            &:nth-child(4) {
                top: 16px;
            }
        }

        &.open {
            #{$blockname}__menu-hamburger__stick:nth-child(1) {
                top: 8px;
                width: 0;
                left: 50%;
            }
            #{$blockname}__menu-hamburger__stick:nth-child(2) {
                transform: rotate(45deg);
            }
            #{$blockname}__menu-hamburger__stick:nth-child(3) {
                transform: rotate(-45deg);
            }
            #{$blockname}__menu-hamburger__stick:nth-child(4) {
                top: 8px;
                width: 0;
                left: 50%;
            }
        }
    }

    .cabinet-menu {
        display: none;
    }
}
@media screen and (max-width: 1024px) {
    .l-header--cabinet {
        $blockname: &;

        position: fixed;
        top: 0;

        display: flex;
        justify-content: space-between;

        max-width: 100%;
        width: 100%;
        padding: 10px 15px;
        background: #f9f9f9;

        border-bottom: 1px solid #cccccc;
        z-index: 1001;

        &__logo-wrap {
        }
        &__contacts {
            flex-flow: column nowrap;
            max-width: unset;
            min-height: 173px;

            &--text,
            &--phone,
            &--email,
            &--works {
                margin-bottom: 8px;
                margin-right: 0;
            }
        }
        &__menu-hamburger {
            position: relative;
            z-index: 1015;
            display: block;
            margin: 5px 0;
            height: 18px;
            order: 4;
        }
        &__menu {
            position: fixed;
            overflow-y: scroll;
            background: $white;
            width: 100%;
            left: 0;
            z-index: 1009;
            top: -100%;
            transform: translateY(-100%);
            transition: 0.7s ease all;
            flex-direction: column;
            align-items: flex-start;
            order: 2;

            &--open {
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;

                display: flex;
                flex-flow: column nowrap;
                justify-content: space-between;
                height: auto;
                padding-bottom: 20px;
                margin-top: 18px;

                overflow-y: auto;
                transition: 0.3s ease all;
                transform: translateY(0);
                pointer-events: auto;
            }
            .cabinet-menu {
                display: flex;
                max-width: unset;
                height: 100%;
                min-height: 300px;
                flex: 1;
            }
        }
        &__mobile-footer {
            display: block;
            justify-self: flex-end;
            text-align: center;
            align-self: center;
            order: 3;
        }
        &__social-icons {
            display: flex;
            margin: 10px 0;
            justify-content: center;
            list-style-type: none;
        }
        &__social-icon {
            margin: 0 5px;
            img {
                max-width: 30px;
                max-height: 30px;
                width: 100%;
                height: 100%;
            }
            &__item {
                display: inline-block;
                width: 30px;
                height: 30px;

                &--instagram {
                    background: url("~@/assets/svg/social/instagram.svg") center /contain no-repeat;
                }
                &--facebook {
                    background: url("~@/assets/svg/social/facebook.svg") center /contain no-repeat;
                }
            }
        }
        &__copyright {
            color: $gray-dim;
            font-size: 14px;
            font-family: $RobotoRegular;
        }

        &--light {}
        &--dark {
            &.open {
                background: $gray-dim-dark;
                border: none;
                &:after {
                    background: $gray-dim-dark;
                    border: none;
                }
                #{$blockname}__logo,
                #{$blockname}__signature {
                    display: none;
                }
                #{$blockname}__menu-hamburger {
                    .menu-hamburger__stick {
                        background: $white;
                    }
                }
            }
            #{$blockname}__menu {
                &--open {
                    background: $gray-dim-dark;
                }
            }
            #{$blockname}__contacts {
                #{$blockname}__contacts--text {
                    display: none;
                }
                #{$blockname}__contacts--phone,
                #{$blockname}__contacts--email,
                #{$blockname}__contacts--words {
                    margin-bottom: 4px;
                }
                #{$blockname}__contacts--phone,
                #{$blockname}__contacts--email {
                    color: #C7C7C7;
                    font-family: $RobotoRegular;
                    font-size: 18px;
                    text-decoration: underline;
                }
            }
            #{$blockname}__social-icon {
                #{$blockname}__social-icon__item--instagram {
                    background: url("~@/assets/svg/social/instagram_white.svg") center /contain no-repeat;
                }
                #{$blockname}__social-icon__item--facebook {
                    background: url("~@/assets/svg/social/facebook_white.svg") center /contain no-repeat;
                }
            }
        }
    }
}
</style>
